import { BigNumber, BigNumberish } from '@ethersproject/bignumber'

export class BigNumberMath {
    static min(...values) {
        let lowest = BigNumber.from(values[0])
        for (let i = 1; i < values.length; i++) {
            const value = BigNumber.from(values[i])
            if (value.lt(lowest)) {
                lowest = value
            }
        }
        return lowest
    }
    static max(...values) {
        let highest = BigNumber.from(values[0])
        for (let i = 1; i < values.length; i++) {
            const value = BigNumber.from(values[i])
            if (value.gt(highest)) {
                highest = value
            }
        }
        return highest
    }
}

export default BigNumberMath
